module.exports = __webpack_public_path__ + "media/images/icons/academy-science-8c23b15ec430853274e1bf5bd208002f.svg";